import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.6724 5.93103V8.60291H19.7271V7.05408L12.9175 3.12244V5.1283L18.0405 8.06677V15.0219L12.9175 17.9603V19.972L19.7271 16.0404V14.4808H21.6724V17.1635L11.9448 22.7806L2.21631 17.1635V5.93103L11.9448 0.313843L21.6724 5.93103ZM4.16162 7.05408V16.0404L10.9712 19.972V17.9232L5.9126 15.0219V8.06677L10.9712 5.16541V3.12244L4.16162 7.05408ZM13.562 7.66345L10.6714 10.7338V8.07654L8.46826 7.66345V15.6488H10.6714V13.0746L12.103 11.5463L13.8657 15.6488H16.2056L14.1548 11.5189H12.1304L15.7651 7.66345H13.562Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }